import { useTrackPageView } from '@/hooks/useTrackPageView';
import Schedule from '@/pages/Schedule';
import { useOpenEntryModal } from './hooks/useOpenEntryModal';

export const ScheduleEntry = () => {
  useOpenEntryModal();
  useTrackPageView('entry');

  return <Schedule />;
};
